<template>
  <div
    :class="route.name"
    class="page-container h-100"
    data-testid="app-container"
  >
    <VApp data-testid="v-app">
      <VMain id="app" data-testid="main-content">
        <RouterView />
      </VMain>
      <VSnackbar
        v-model="newAppIsAvailable"
        :timeout="-1"
        location="center"
        class="new-app-available"
        color="secondary"
        data-testid="new-app-snackbar"
      >
        <div class="content" data-testid="snackbar-content">
          {{ t("newAppText") }}
        </div>
        <template #actions>
          <VBtn data-testid="refresh-button" color="primary" @click="update">
            <VIcon>mdi-refresh</VIcon>
            {{ t("refresh") }}
          </VBtn>
        </template>
      </VSnackbar>
    </VApp>
  </div>
</template>

<script setup>
  import { ref, onMounted, getCurrentInstance } from "vue";
  import { useRoute } from "vue-router";
  import { useI18n } from "vue-i18n";

  const { t } = useI18n();

  const route = useRoute();
  const newAppIsAvailable = ref(false);
  const instance = getCurrentInstance().proxy;

  onMounted(async () => {
    if (instance.$workbox) {
      instance.$workbox.addEventListener("waiting", () => {
        newAppIsAvailable.value = true;
      });
    }
  });

  const update = async () => {
    newAppIsAvailable.value = false;
    await instance.$workbox.messageSW({ type: "SKIP_WAITING" });
  };
</script>

<style lang="scss">
  button:focus {
    outline: 0;
  }

  a {
    color: $label-gray !important;
    text-decoration: none;
  }

  :deep(.new-app-available) {
    .v-snack__wrapper {
      min-width: 400px;
      max-width: 600px;
    }

    .v-snack__action {
      width: 100%;
      margin: 0;
      .v-btn {
        margin: auto;
      }
    }
  }
</style>

<i18n>
{
  "fr": {
    "refresh": "Rafraîchir",
    "newAppText": "Une nouvelle version de Rapsotec est disponible, veuillez cliquer sur rafraîchir."
  },
  "en": {
    "refresh": "Refresh",
    "newAppText": "A new version of Rapsotec is available, please click refresh."
  }
}
</i18n>
